import { render, staticRenderFns } from "./TableEdit.vue?vue&type=template&id=c5b3d258&"
import script from "./TableEdit.vue?vue&type=script&lang=js&"
export * from "./TableEdit.vue?vue&type=script&lang=js&"
import style0 from "./TableEdit.vue?vue&type=style&index=0&id=c5b3d258&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports